import React, { FunctionComponent } from 'react';
import { BaseUploadCard, FileType, UploadStatus } from '@shopee/chatbot-ui/lib/components/BaseUpload';
import dateLib from '@/utils/dateLib/moment';
import reporter from '@/utils/report';

export interface VideoUploadProps {
  coverUrl: string;
  duration: number;
  status: UploadStatus;
  onRemove: () => void;
  onPreview: () => void;
  showRemoveIcon?: boolean;
}

export const formatDuration = (duration: number) => {
  const formatDuration = dateLib.getDuration(Math.floor(duration / 1000));
  return `${formatDuration[2]}:${formatDuration[3].toString().padStart(2, '0')}`;
};

export const VideoUploadWrapper: FunctionComponent<VideoUploadProps> = (props) => {
  const { coverUrl, duration, status, showRemoveIcon } = props;

  const handleRemove = () => {
    props.onRemove();
    if (status === UploadStatus.Loading) {
      reporter.apiBatchReport({ type: 'count', value: { label: 'probing_form_upload_video_cancel' }});
    }
  };

  return (
    <BaseUploadCard
      file={{
        type: FileType.Video,
        status,
        coverUrl,
        duration: formatDuration(duration),
      }}
      onRemove={handleRemove}
      onPreview={props.onPreview}
      showRemoveIcon={showRemoveIcon}
    />
  );
};

